export enum ConditionsTariffEnum {
  STANDAR = 'STANDAR',
  PERSONALIZED = 'PERSONALIZED',
  MANUAL = 'MANUAL',
}
